import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
})

const goLogin = () => {
  localStorage.removeItem('access_token')
  localStorage.removeItem('token_expire')
  window.location.href = `/login?redirect=${encodeURIComponent(window.location.href)}`
}

// 请求拦截
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token')
    const tokenExpire = localStorage.getItem('token_expire')
    if (
      (!config.url.includes('/token') ||
        config.url.includes('/token/logout')) &&
      !window.location.pathname.includes('/login')
    ) {
      // 添加token
      if (token && tokenExpire) {
        const now = new Date().getTime()
        if (now > tokenExpire) {
          goLogin()
          return Promise.reject('token过期')
        } else {
          config.headers['Authorization'] = `Bearer ${token}`
        }
      } else {
        goLogin()
        return Promise.reject('未登录')
      }
    } else {
      if (!config.url.includes('/token') && !token) {
        return Promise.reject('未登录')
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截
instance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      const data = response.data
      if (data.code === 200) {
        return data.data
      } else if (data.code === 401) {
        // 企业微信跳转
        if (navigator.userAgent.toLowerCase().includes('wxwork')) {
          window.location.href = '/ai-cms/token/render'
        } else {
          // token过期跳转登录页
          goLogin()
        }
        return Promise.reject(data)
      } else {
        return Promise.reject({
          ...data,
          ...(response.config?.noToast ? { noToast: true } : {}),
        })
      }
    } else {
      return Promise.reject(response)
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance
